export const cn = {
    imagePreprocessor: {
        cropText: '裁剪',
        deleteText: '删除',
        editImage: '旋转或裁剪图片',
        fileLimit: '文件小于4M',
        isUploading: '正在上传中...',
        rotateText: '旋转',
        supportImg: '支持常用图片格式(jpg, png)',
        tagDrap: '点击上传或者拖拽一个图片放到这里',
        uploadText: '上传',
        overSizeMsg: '图片太大啦，',
        overSizeReason: '不能超过4MB哦！',
        typeErrorMsg: '无法识别上传的图片呢...',
        typeErrorReason: '只能识别JPG和PNG哦',
        unknownError: '服务器存在异常，请联系系统管理员或稍后再试。',
        disabledUpload: '系统管理员已禁用该功能',
    },
    designSearch: {
        nodataTip: {
            reasonTitle: '未找到与您的检索语句或者图片匹配的结果，建议:',
            reasonList: '上传更加清晰的图片-&-裁剪图片的关键内容-&-旋转图片方向-&-检查检索语句拼写是否正确-&-检查检索语句标点符号',
        },
        designPatents: '外观设计',
        utilityPatents: '实用新型',
        successfullyDeleted: '删除成功',
        deleteConfirm: '确定删除该上传图片？',
        deleteTitle: '删除上传的图片',
    },
    smartSearch: {
        nodataTip: {
            reasonTitle: '没有找到与您的检索语句匹配的结果，建议:',
            reasonList: '检查拼写是否正确-&-检查标点符号-&-尝试使用同义词-&-扩大搜索范围',
        },
    },
    noveltySearch: {
        errorTip: {
            title: '没有找到近似的结果。',
            tip1: '这个想法的创新度不错，也许您可以考虑把它申请专利。',
            tip2: '如果您对方案描述还有补充完善，也可以做持续的调整，多次验证。',
        },
    },
    unversalSearch: {
        title: 'Eureka 一下！',
        subTitle: '描述您现在遇到的技术难点或期望获得的技术突破，我们将在浩瀚的知识海洋中为您找到相关度最高的现有技术方案。',
        searchBtn: '搜 索',
        searchImageBtn: '图像检索',
        imageSearchTip: '进行图像检索',
        historyLink: '检索历史',
        maxQueryLengthError: '检索内容长度过长',
        requiredError: '请输入检索内容后，再进行检索',
        searchPlaceholder: '请输入技术关键词或公司名, 快速定位全球专利',
        searchImagePlaceholder: '请输入关键字、公司名',
        suggestion: {
            HISTORY: '历史记录',
            AUTOCOMPLETE: '推荐词',
            COMPANY: '推荐公司',
            BENEFIT: '猜你想搜',
        },
    },
    global: {
        btn: {
            confirm: '确定',
            submit: '提交',
            delete: '删除',
            cancel: '取消',
            showless: '收起',
            clear: '清空',
            to: '到',
            add: '添加',
        },
        solutionType: {
            PATENT: '专利',
            NPL: '文献',
        },
    },
    advSearch: {
        title: '高级检索',
        view: '查看结果',
        unSupported: '当前条件不支持使用高级搜索',
        monitorTip: '请先搜索您感兴趣的技术领域。<br />您可以在搜索结果页面设置监控。',
        noPermission: '您的账号权限不支持高级检索，<a target="_blank" class="text-eureka-600" href="/user-setting/package?open_update_auto=1&source_type=advance_upgrade">点击去升级</a>',
        range: {
            all: '全球数据库',
            ws: '工作空间',
        },
        groups: {
            general: '通用',
            material: '材料',
            other: '其他',
            text: '文本',
            company: '公司/人',
            classification: '分类',
            date: '日期',
        },
        fieldTip: {
            TACD_ALL: '全文字段数据范围包括标题、摘要、权利要求和说明书',
            ANCS: '所有者字段是当前申请(专利权)人的标准化数据；标准化处理是指在原始数据基础上，对标点符号、大小写、缩写、翻译、公司后缀等做了统一化处理。',
            VF_ANCS: '公司数据经过统一标准化处理，点击公司名称会自动展示所有子公司。',
        },
        noPaperFieldTip: '您的输入包含非文献字段，如{field}，会影响结果精准度。',
        placeholder: {
            TACD_ALL: '例如输入：汽车',
            TA_ALL: '@:advSearch.placeholder.TACD_ALL',
            TAC_ALL: '@:advSearch.placeholder.TACD_ALL',
            TTL_ALL: '@:advSearch.placeholder.TACD_ALL',
            DESC_ALL: '@:advSearch.placeholder.TACD_ALL',
            VF_TACD: '例如输入：汽车',
            VF_TA: '@:advSearch.placeholder.TACD_ALL',
            VF_TAC: '@:advSearch.placeholder.TACD_ALL',
            VF_TTL: '@:advSearch.placeholder.TACD_ALL',
            VF_DESC: '@:advSearch.placeholder.TACD_ALL',
            PROBLEM_SUM: '例如输入：透气性差',
            BENEFIT_SUM: '例如输入：提高稳定性',
            DESC_E: '例如输入：光伏电池',
            ANCS: '例如输入：华为',
            VF_ANCS: '@:advSearch.placeholder.ANCS',
            IN: '例如输入：李书福',
            TTC: '例如输入：“麦克风”',
            ADC: '例如输入：“发动机制造”',
            NEV: '例如输入：电机',
            IPC: '输入IPC分类号如A21B3/04',
        },
        material: {
            reportSuccess: '感谢您的上报。我们会尽快将其收录',
            propertyReport: '未找到匹配的条目。您可以点击<span class="report text-eureka-500 cursor-pointer hover:underline">上报</span>，我们会尽快将其收录',
        },
        materialPlaceholder: {
            TTC: '例如输入：高分子化学',
            ADC: '例如输入：高分子粘合剂添加剂',
            NEV: '例如输入：燃料电池催化剂',
            IPC: '例如输入：C08C19/00',
            PN: '例如输入：CN109933702B',
            SIMPLE_LEGAL_STATUS: '请选择',
            VF_KEYWORD: '例如输入：华为，CN109933702B，涂料',
            TEXT: '例如输入：提高丙烯酸乳液的耐水性',
            SUBSTANCE_IDS: '例如输入：聚乙烯，Al2O3',
            MATERIAL: '例如输入：分子量',
            POLYMER_PPI_IDS: '例如输入：接枝',
            METAL_PPI_IDS: '例如输入：增材制造',
            CERAMIC_PPI_IDS: '例如输入：模压成型',
            TACD_ALL: '例如输入：涂料',
            VF_TACD: '@:advSearch.materialPlaceholder.TACD_ALL',
            VF_TTL: '@:advSearch.materialPlaceholder.TACD_ALL',
            VF_DESC: '@:advSearch.materialPlaceholder.TACD_ALL',
            TA_ALL: '@:advSearch.materialPlaceholder.TACD_ALL',
            TAC_ALL: '@:advSearch.materialPlaceholder.TACD_ALL',
            TTL_ALL: '@:advSearch.materialPlaceholder.TACD_ALL',
            VF_ABST: '@:advSearch.materialPlaceholder.TACD_ALL',
            VF_CLMS: '@:advSearch.materialPlaceholder.TACD_ALL',
            DESC_ALL: '@:advSearch.materialPlaceholder.TACD_ALL',
            PROBLEM_SUM: '@:advSearch.materialPlaceholder.TACD_ALL',
            BENEFIT_SUM: '@:advSearch.materialPlaceholder.TACD_ALL',
            DESC_E: '@:advSearch.materialPlaceholder.TACD_ALL',
            ANCS: '@:advSearch.placeholder.ANCS',
            VF_ANCS: '@:advSearch.placeholder.ANCS',
            IN: '@:advSearch.placeholder.IN',
        },
        invalid: {
            logicNotErrorTip: 'NOT在搜索語句開頭不可用',
            length: '当前字段的输入值长度超过上限',
            date: '无效的日期范围',
        },
        unsupported: '当前检索条件不支持文献检索',
        preview: '当前检索{count}条数据',
        workspace: {
            select: '请选择或者搜索文件夹',
            haveSelected: '已选择',
        },
    },
}

export const en = {
    imagePreprocessor: {
        cropText: 'Crop',
        deleteText: 'Delete',
        editImage: 'Rotate or Crop the image',
        fileLimit: 'File size limit is 4MB',
        isUploading: 'Uploading...',
        rotateText: 'Rotate',
        supportImg: 'Supports JPG and PNG',
        tagDrap: 'Click Upload or drag & drop image here',
        uploadText: 'Upload',
        overSizeMsg: 'The image is too large to upload.',
        overSizeReason: 'Upload Images cannot exceed 4 MB',
        typeErrorMsg: 'Sorry, the image upload failed.',
        typeErrorReason: 'Not a valid image (JPG, PNG)',
        unknownError: 'The server is abnormal, please contact the system administrator or try again later.',
        disabledUpload: 'System administrator has disabled this feature',
    },
    designSearch: {
        nodataTip: {
            reasonTitle: 'No results match your query or image. We suggest you:',
            reasonList: 'Upload a clearer image-&-Crop only the key content of the image-&-Rotate the image-&-Check the spelling of the search statement-&-Check the punctuation of the search statement',
        },
        designPatents: 'Design patents',
        utilityPatents: 'Utility models',
        successfullyDeleted: 'Successfully deleted',
        deleteConfirm: 'Are you sure you want to delete the uploaded image?',
        deleteTitle: 'Delete Uploaded image',
    },
    smartSearch: {
        nodataTip: {
            reasonTitle: 'No patents match your query this time. Suggestions:',
            reasonList: 'Check your spelling-&-Check your punctuation-&-Try using synonyms-&-Broaden your search',
        },
    },
    noveltySearch: {
        errorTip: {
            title: 'No similar results found.',
            tip1: 'Your idea could be novel.',
            tip2: 'Consider adjusting your input to more thoroughly assess novelty.',
        },
    },
    unversalSearch: {
        title: 'Get started in Eureka!',
        subTitle: 'Describe the technical challenge you are encountering or your technical breakthrough goal and our powerful search function will retrieve the most relevant technology solutions for you.',
        searchBtn: 'Search',
        searchImageBtn: 'Image Search',
        imageSearchTip: 'Upload image to search',
        historyLink: 'History',
        maxQueryLengthError: 'Search content length exceeded',
        requiredError: 'Enter search contents before proceeding',
        searchPlaceholder: 'Please enter technical keywords or company names',
        searchImagePlaceholder: 'Input keywords or company name',
        suggestion: {
            HISTORY: 'History',
            AUTOCOMPLETE: 'Recommend Keywords',
            COMPANY: 'Recommend Company',
            BENEFIT: 'You might want to know',
        },
    },
    global: {
        btn: {
            confirm: 'Confirm',
            submit: 'Submit',
            delete: 'Delete',
            cancel: 'Cancel',
            showless: 'Collapse',
            clear: 'Clear',
            to: 'to',
            add: 'Add',
        },
        solutionType: {
            PATENT: 'Patent',
            NPL: 'Literature',
        },
    },
    advSearch: {
        title: 'Advanced Search',
        view: 'View Result',
        unSupported: 'Advanced search is not supported under the current conditions',
        monitorTip: 'Please start by searching for the technology areas you are interested in.<br />You can set up monitoring on the search results page.',
        noPermission: 'Your account permissions do not support Advanced Search, <a target="_blank" class="text-eureka-600" href="/user-setting/package?open_update_auto=1&source_type=advance_upgrade">Click to upgrade</a>',
        range: {
            all: 'Global Database',
            ws: 'Workspace',
        },
        groups: {
            general: 'General',
            material: 'Materials',
            other: 'Others',
            text: 'Text',
            company: 'Company & People',
            classification: 'Category',
            date: 'Date',
        },
        fieldTip: {
            TACD_ALL: 'Full text field data scope includes title, abstract, claims and description',
            ANCS: 'The owner field is the standardized data of the current applicant (patent right); standardized processing refers to the unified processing of punctuation, capitalization, abbreviation, translation, company suffix, etc. based on the original data.',
            VF_ANCS: 'Company data is processed through unified standardization. Clicking on the company name will automatically display all its subsidiaries.',
        },
        noPaperFieldTip: 'Your input contains non-document fields, such as {field}, which will affect the accuracy of the results.',
        placeholder: {
            TACD_ALL: 'Example: car',
            TA_ALL: '@:advSearch.placeholder.TACD_ALL',
            TAC_ALL: '@:advSearch.placeholder.TACD_ALL',
            TTL_ALL: '@:advSearch.placeholder.TACD_ALL',
            DESC_ALL: '@:advSearch.placeholder.TACD_ALL',
            VF_TACD: 'Example: car',
            VF_TA: '@:advSearch.placeholder.TACD_ALL',
            VF_TAC: '@:advSearch.placeholder.TACD_ALL',
            VF_TTL: '@:advSearch.placeholder.TACD_ALL',
            VF_DESC: '@:advSearch.placeholder.TACD_ALL',
            PROBLEM_SUM: 'Example: "poor air permeability"',
            BENEFIT_SUM: 'Example: "Improve stability"',
            DESC_E: 'Example: "solar battery"',
            ANCS: 'Example: Apple',
            VF_ANCS: '@:advSearch.placeholder.ANCS',
            IN: 'Example: Steve Jobs',
            TTC: 'Example: "solar battery"',
            ADC: 'Example: "engine manufacture"',
            NEV: 'For example: Motor',
            IPC: 'Enter a IPC code, Example: A61K',
        },
        material: {
            reportSuccess: 'Thank you for your report. We will include it as soon as possible',
            propertyReport: 'No matched category. You can click <span class="report text-eureka-500 cursor-pointer hover:underline">report</span> and we will Include it as soon as possible',
        },
        materialPlaceholder: {
            TTC: 'Example: Polymer chemistry',
            ADC: 'Example: Adhesive additives',
            NEV: 'Example: Fuel cell core components',
            IPC: 'Example: C08C19/00',
            PN: 'Example: US11126668B2',
            SIMPLE_LEGAL_STATUS: 'Please select',
            VF_KEYWORD: 'Example: Apple, US11126668B2, Coating',
            TEXT: 'Example: Improve water resistance of acrylic emulsion',
            SUBSTANCE_IDS: 'Example: Polyethylene, Al2O3',
            MATERIAL: 'Example: Molecular weight',
            POLYMER_PPI_IDS: 'Example: Grafting',
            METAL_PPI_IDS: 'Example: Additive manufacturing',
            CERAMIC_PPI_IDS: 'Example: Moulding',
            TACD_ALL: 'Example: Coating',
            VF_TACD: '@:advSearch.materialPlaceholder.TACD_ALL',
            VF_TTL: '@:advSearch.materialPlaceholder.TACD_ALL',
            VF_DESC: '@:advSearch.materialPlaceholder.TACD_ALL',
            TA_ALL: '@:advSearch.materialPlaceholder.TACD_ALL',
            TAC_ALL: '@:advSearch.materialPlaceholder.TACD_ALL',
            TTL_ALL: '@:advSearch.materialPlaceholder.TACD_ALL',
            VF_ABST: '@:advSearch.materialPlaceholder.TACD_ALL',
            VF_CLMS: '@:advSearch.materialPlaceholder.TACD_ALL',
            DESC_ALL: '@:advSearch.materialPlaceholder.TACD_ALL',
            PROBLEM_SUM: '@:advSearch.materialPlaceholder.TACD_ALL',
            BENEFIT_SUM: '@:advSearch.materialPlaceholder.TACD_ALL',
            DESC_E: '@:advSearch.materialPlaceholder.TACD_ALL',
            ANCS: '@:advSearch.placeholder.ANCS',
            VF_ANCS: '@:advSearch.placeholder.ANCS',
            IN: '@:advSearch.placeholder.IN',
        },
        invalid: {
            logicNotErrorTip: 'NOT cannot start a search query',
            length: 'The input value length of the current field exceeds the upper limit',
            date: 'Invalid date range',
        },
        unsupported: 'The current search conditions do not support literature search',
        preview: 'Found {count} record|Found {count} records',
        workspace: {
            select: 'Please select or search for a folder',
            haveSelected: 'Selected',
        },
    },
}

export const jp = {
    imagePreprocessor: {
        cropText: '切り抜き',
        deleteText: '削除する',
        editImage: '画像を回転またはトリミング',
        fileLimit: 'ファイルサイズ４M以下',
        isUploading: 'アップロード中...',
        rotateText: '回転させる',
        supportImg: '画像フォーマト(jpg, png)',
        tagDrap: '画像をアップロードまたはドラッグしてここにドロップします',
        uploadText: 'アップロードする',
        overSizeMsg: '画像が大きすぎ！',
        overSizeReason: '４MBを超えることはできません！',
        typeErrorMsg: 'アップロードされた画像を識別できません。',
        typeErrorReason: 'JPGとPNGしか識別できません',
        unknownError: 'サーバーが異常です。システム管理者に連絡するか、後で再試行してください。',
        disabledUpload: 'システム管理者がこの機能を無効にしました',
    },
    designSearch: {
        nodataTip: {
            reasonTitle: '検索結果または画像と一致する結果が見つかりませんでした，提案:',
            reasonList: 'より鮮明な画像をアップロードする-&-画像の主要なコンテンツをトリミングする-&-画像の方向を回転させる-&-検索ステートメントのスペルが正しいかどうかを確認してください-&-検索ステートメントの句読点を確認する',
        },
        designPatents: '意匠',
        utilityPatents: '実用新案',
        successfullyDeleted: '削除しました',
        deleteConfirm: 'アップロードした画像を必ず削除してください?',
        deleteTitle: 'アップロードした画像を削除する',
    },
    smartSearch: {
        nodataTip: {
            reasonTitle: '検索結果と一致する結果が見つかりませんでした，提案:',
            reasonList: 'つづりが正しいか確認してください-&-句読点をチェックする-&-同義語を使ってみる-&-検索範囲を広げる',
        },
    },
    noveltySearch: {
        errorTip: {
            title: '内容が類似するものは見つかりませんでした。',
            tip1: '類似するものはありません。',
            tip2: '革新的なアイデアです。特許化する価値があるかもしれません。',
        },
    },
    unversalSearch: {
        title: 'Eurekaしてみましょう！',
        subTitle: '技術について、今お持ちする問題点あるいはご期待されているブレイクスルーを説明して頂ければ、膨大な知識の海から最も適切な既存の技術手段を見出します。',
        searchBtn: '検 索',
        searchImageBtn: '画像検索',
        imageSearchTip: '画像検索を行う',
        historyLink: '検索履歴',
        maxQueryLengthError: '検索内容が長すぎています。',
        requiredError: '検索条件を入力した後、再度検索してください',
        searchPlaceholder: '技術キーワードまたは企業名でグローバル特許を迅速に検索',
        searchImagePlaceholder: 'キーワード、会社名を入力してください',
        suggestion: {
            HISTORY: '履歴',
            AUTOCOMPLETE: 'おすすめのキーワード',
            COMPANY: 'おすすめ企業',
            BENEFIT: 'あなたが知りたいと思う',
        },
    },
    global: {
        btn: {
            confirm: '確定',
            submit: '提出',
            delete: '削除',
            cancel: 'キャンセル',
            showless: '折り畳む',
            clear: 'クリア',
            to: 'まで',
            add: '追加',
        },
        solutionType: {
            PATENT: '特許',
            NPL: '文献',
        },
    },
    advSearch: {
        title: '高度検索',
        view: '結果を見る',
        unSupported: '現在の条件では高度な検索はサポートされていません',
        monitorTip: '興味のある技術分野を検索することから始めてください。<br />検索結果ページでモニタリングを設定できます。',
        noPermission: 'アカウントの権限は高度な検索をサポートしていません、<a target="_blank" class="text-eureka-600" href="/user-setting/package?open_update_auto=1&source_type=advance_upgrade">クリックしてアップグレード</a>',
        range: {
            all: '全データベース',
            ws: 'ワークスペース',
        },
        groups: {
            general: 'General',
            material: '材料',
            other: '他',
            text: 'テキスト',
            company: '会社・人',
            classification: '分類',
            date: '日付',
        },
        fieldTip: {
            TACD_ALL: '全文フィールドのデータ範囲には、タイトル、要約、特許請求の範囲、および説明が含まれます',
            ANCS: '所有者フィールドは、現在の出願人（特許権）の標準化されたデータであり、標準化処理とは、元のデータに基づいて、句読点、大文字、略語、翻訳、社名などを統一的に処理することを指します。',
            VF_ANCS: '会社データは統一された基準で処理されています。会社名をクリックすると、自動的にすべての子会社が表示されます。',
        },
        noPaperFieldTip: '入力内容には文献以外のフィールドが含まれており、結果の精度に影響します。',
        placeholder: {
            TACD_ALL: '例：車',
            TA_ALL: '@:advSearch.placeholder.TACD_ALL',
            TAC_ALL: '@:advSearch.placeholder.TACD_ALL',
            TTL_ALL: '@:advSearch.placeholder.TACD_ALL',
            DESC_ALL: '@:advSearch.placeholder.TACD_ALL',
            VF_TACD: '例：車',
            VF_TA: '@:advSearch.placeholder.TACD_ALL',
            VF_TAC: '@:advSearch.placeholder.TACD_ALL',
            VF_TTL: '@:advSearch.placeholder.TACD_ALL',
            VF_DESC: '@:advSearch.placeholder.TACD_ALL',
            PROBLEM_SUM: '例：通気性が低い',
            BENEFIT_SUM: '例："Improve stability"',
            DESC_E: '例：光電池',
            ANCS: '例：日立',
            VF_ANCS: '@:advSearch.placeholder.ANCS',
            IN: '例：Steve Jobs',
            TTC: '例："solar battery"',
            ADC: '例："engine manufacture"',
            NEV: '例えば入力：電動機',
            IPC: 'IPC コードを入力します。例: A61K',
        },
        material: {
            reportSuccess: 'ご報告いただきありがとうございます。できるだけ早く収録いたします。',
            propertyReport: '一致する項目が見つかりませんでした。<span class="report text-eureka-500 cursor-pointer hover:underline">報告</span>をクリックすると、できるだけ早く収録いたします。',
        },
        materialPlaceholder: {
            TTC: 'Example：Polymer chemistry',
            ADC: 'Example：Adhesive additives',
            NEV: 'Example：Fuel cell core components',
            IPC: 'Example：C08C19/00',
            PN: 'Example：JP2020502706A',
            SIMPLE_LEGAL_STATUS: '選択してください',
            VF_KEYWORD: '例：日立，JP2020502706A，Coating',
            TEXT: '例：アクリルエマルジョンの耐水性を向上',
            SUBSTANCE_IDS: '例：Polyethylene，Al2O3',
            MATERIAL: '例：Molecular weight',
            POLYMER_PPI_IDS: '例：Grafting',
            METAL_PPI_IDS: '例：Additive manufacturing',
            CERAMIC_PPI_IDS: '例：Additive manufacturing',
            TACD_ALL: '例：Coating',
            VF_TACD: '@:advSearch.materialPlaceholder.TACD_ALL',
            VF_TTL: '@:advSearch.materialPlaceholder.TACD_ALL',
            VF_DESC: '@:advSearch.materialPlaceholder.TACD_ALL',
            TA_ALL: '@:advSearch.materialPlaceholder.TACD_ALL',
            TAC_ALL: '@:advSearch.materialPlaceholder.TACD_ALL',
            TTL_ALL: '@:advSearch.materialPlaceholder.TACD_ALL',
            VF_ABST: '@:advSearch.materialPlaceholder.TACD_ALL',
            VF_CLMS: '@:advSearch.materialPlaceholder.TACD_ALL',
            DESC_ALL: '@:advSearch.materialPlaceholder.TACD_ALL',
            PROBLEM_SUM: '@:advSearch.materialPlaceholder.TACD_ALL',
            BENEFIT_SUM: '@:advSearch.materialPlaceholder.TACD_ALL',
            DESC_E: '@:advSearch.materialPlaceholder.TACD_ALL',
            ANCS: '@:advSearch.placeholder.ANCS',
            VF_ANCS: '@:advSearch.placeholder.ANCS',
            IN: '@:advSearch.placeholder.IN',
        },
        invalid: {
            logicNotErrorTip: '検索ステートメントの先頭でNOTを使用できません',
            length: '現在のフィールドの入力値の長さが上限を超えています',
            date: '無効な日付範囲',
        },
        unsupported: '現在の検索条件は文献検索をサポートしていません',
        preview: '検索 {count} 特許',
        workspace: {
            select: 'フォルダを選択または検索してください',
            haveSelected: '選ばれた',
        },
    },
}

export const tw = {
    imagePreprocessor: {
        cropText: '裁剪',
        deleteText: '刪除',
        editImage: '旋轉或裁剪圖像',
        fileLimit: '文件小於4M',
        isUploading: '正在上傳中...',
        rotateText: '旋轉',
        supportImg: '支持常用圖片格式(jpg, png)',
        tagDrap: '點擊上傳或者拖拽一個圖片放到這裡',
        uploadText: '上傳',
        overSizeMsg: '圖片太大啦，',
        overSizeReason: '不能超過4MB哦！',
        typeErrorMsg: '無法識別上傳的圖片呢...',
        typeErrorReason: '只能識別JPG和PNG哦',
        unknownError: '服務器存在異常，請聯系系統管理員或稍後再試。',
        disabledUpload: '系統管理員已禁用該功能',
    },
    designSearch: {
        nodataTip: {
            reasonTitle: '未找到與您的檢索語句或者圖片匹配的結果，建議:',
            reasonList: '上傳更加清晰的圖片-&-裁剪圖片的關鍵內容-&-旋轉圖片方向-&-檢查檢索語句拼寫是否正確-&-檢查檢索語句標點符號',
        },
        designPatents: '外觀設計',
        utilityPatents: '實用新型',
        successfullyDeleted: '刪除成功',
        deleteConfirm: '確定刪除該上傳的圖片?',
        deleteTitle: '刪除上傳的圖片',
    },
    smartSearch: {
        nodataTip: {
            reasonTitle: '沒有找到與您的檢索語句匹配的結果，建議:',
            reasonList: '檢查拼寫是否正確-&-檢查標點符號-&-嘗試使用同義詞-&-擴大搜索範圍',
        },
    },
    noveltySearch: {
        errorTip: {
            title: '沒有找到近似的結果。',
            tip1: '這個想法的創新度不錯，也許您可以考慮把它申請專利。',
            tip2: '如果您對方案描述還有補充完善，也可以做持續的調整，多次驗證。',
        },
    },
    unversalSearch: {
        title: 'Eureka 一下！',
        subTitle: '描述您現在遇到的技術難點或期望獲得的技術突破，我們將在浩瀚的知識海洋中為您找到相關度最高的現有技術方案。',
        searchBtn: '搜 索',
        searchImageBtn: '圖像檢索',
        imageSearchTip: '進行圖像檢索',
        historyLink: '檢索歷史',
        maxQueryLengthError: '檢索內容長度過長',
        requiredError: '請輸入檢索內容後，再進行檢索',
        searchPlaceholder: '請輸入技術關鍵字或公司名稱, 快速定位全球專利',
        searchImagePlaceholder: '請輸入關鍵字、公司名',
        suggestion: {
            HISTORY: '歷史記錄',
            AUTOCOMPLETE: '推薦詞',
            COMPANY: '推薦公司',
            BENEFIT: '猜你想搜',
        },
    },
    global: {
        btn: {
            confirm: '確定',
            submit: '提交',
            delete: '刪除',
            cancel: '取消',
            showless: '收起',
            clear: '清空',
            to: '到',
            add: '添加',
        },
        solutionType: {
            PATENT: '專利',
            NPL: '文獻',
        },
    },
    advSearch: {
        title: '高級檢索',
        view: '查看結果',
        unSupported: '當前條件不支持使用高級搜索',
        monitorTip: '請先搜索您感興趣的技術領域。<br />您可以在搜索結果頁面設置監控。',
        noPermission: '您的賬號權限不支持高級檢索，<a target="_blank" class="text-eureka-600" href="/user-setting/package?open_update_auto=1&source_type=advance_upgrade">點擊去升級</a>',
        range: {
            all: '全球數據庫',
            ws: '工作空間',
        },
        groups: {
            general: '通用',
            material: '材料',
            other: '其他',
            text: '文本',
            company: '公司/人',
            classification: '分類',
            date: '日期',
        },
        fieldTip: {
            TACD_ALL: '全文字段數據範圍包括標題、摘要、權利要求和說明書',
            ANCS: '所有者字段是當前申請(專利權)人的標準化數據；標準化處理是指在原始數據基礎上，對標點符號、大小寫、縮寫、翻譯、公司後綴等做了統一化處理。',
            VF_ANCS: '公司資料經過統一標準化處理，點選公司名稱會自動展示所有子公司。',
        },
        noPaperFieldTip: '您的輸入包含非文獻字段，如{field}，會影響結果精準度。',
        placeholder: {
            TACD_ALL: '例如輸入：汽車',
            TA_ALL: '@:advSearch.placeholder.TACD_ALL',
            TAC_ALL: '@:advSearch.placeholder.TACD_ALL',
            TTL_ALL: '@:advSearch.placeholder.TACD_ALL',
            DESC_ALL: '@:advSearch.placeholder.TACD_ALL',
            VF_TACD: '例如輸入：汽車',
            VF_TA: '@:advSearch.placeholder.TACD_ALL',
            VF_TAC: '@:advSearch.placeholder.TACD_ALL',
            VF_TTL: '@:advSearch.placeholder.TACD_ALL',
            VF_DESC: '@:advSearch.placeholder.TACD_ALL',
            PROBLEM_SUM: '例如輸入：透氣性差',
            BENEFIT_SUM: '例如輸入：提高穩定性',
            DESC_E: '例如輸入：光伏電池',
            ANCS: '例如輸入：華為',
            VF_ANCS: '@:advSearch.placeholder.ANCS',
            IN: '例如輸入：李書福',
            TTC: '例如輸入：「麥克風」',
            ADC: '例如輸入：「發動機製造」',
            NEV: '例如輸入：電機',
            IPC: '輸入IPC分類號如A21B3/04',
        },
        material: {
            reportSuccess: '感謝您的上報。我們會儘快將其收錄。',
            propertyReport: '未找到匹配的條目。您可以點擊<span class="report text-eureka-500 cursor-pointer hover:underline">上報</span>，我們會盡快將其收錄',
        },
        materialPlaceholder: {
            TTC: '例如输入：高分子化学',
            ADC: '例如输入：高分子粘合剂添加剂',
            NEV: '例如输入：燃料电池催化剂',
            IPC: '例如输入：C08C19/00',
            PN: '例如输入：CN109933702B',
            SIMPLE_LEGAL_STATUS: '请选择',
            VF_KEYWORD: '例如输入：华为，CN109933702B，涂料',
            TEXT: '例如输入：提高丙烯酸乳液的耐水性',
            SUBSTANCE_IDS: '例如输入：聚乙烯，Al2O3',
            MATERIAL: '例如输入：分子量',
            POLYMER_PPI_IDS: '例如输入：接枝',
            METAL_PPI_IDS: '例如输入：增材制造',
            CERAMIC_PPI_IDS: '例如输入：模压成型',
            TACD_ALL: '例如输入：涂料',
            VF_TACD: '@:advSearch.materialPlaceholder.TACD_ALL',
            VF_TTL: '@:advSearch.materialPlaceholder.TACD_ALL',
            VF_DESC: '@:advSearch.materialPlaceholder.TACD_ALL',
            TA_ALL: '@:advSearch.materialPlaceholder.TACD_ALL',
            TAC_ALL: '@:advSearch.materialPlaceholder.TACD_ALL',
            TTL_ALL: '@:advSearch.materialPlaceholder.TACD_ALL',
            VF_ABST: '@:advSearch.materialPlaceholder.TACD_ALL',
            VF_CLMS: '@:advSearch.materialPlaceholder.TACD_ALL',
            DESC_ALL: '@:advSearch.materialPlaceholder.TACD_ALL',
            PROBLEM_SUM: '@:advSearch.materialPlaceholder.TACD_ALL',
            BENEFIT_SUM: '@:advSearch.materialPlaceholder.TACD_ALL',
            DESC_E: '@:advSearch.materialPlaceholder.TACD_ALL',
            ANCS: '@:advSearch.placeholder.ANCS',
            VF_ANCS: '@:advSearch.placeholder.ANCS',
            IN: '@:advSearch.placeholder.IN',
        },
        invalid: {
            logicNotErrorTip: 'NOT在搜索語句開頭不可用',
            length: '當前字段的輸入值長度超過上限',
            date: '無效的日期範圍',
        },
        unsupported: '當前檢索條件不支持文獻檢索',
        preview: '當前檢索{count}條數據',
        workspace: {
            select: '請選擇或者搜索文件夾',
            haveSelected: '已選擇',
        },
    },
}

export const inputUniversalLocale = {
    cn, en, jp, tw,
}
